import { GENERIC_ACTION } from '../SearchResults/logic'

const INITIAL_STATE = {
  data: {},
  loading: false,
  error: false,
  flag: false,
}

const GET_PROJECT_NUMBERS = 'GET_PROJECT_NUMBERS'
const GET_PROJECT_NUMBERS_SUCCESS = 'GET_PROJECT_NUMBERS_SUCCESS'
const GET_PROJECT_NUMBERS_FAILURE = 'GET_PROJECT_NUMBERS_FAILURE'

export const getProjectNumbersAction = (payload, meta = {}) => {
  return ({
    type: GENERIC_ACTION,
    payload,
    meta: {
      actionType: GET_PROJECT_NUMBERS,
      url: `${process.env.apiUrl}v0/projects/getProjectNumbers`,
      method: 'GET',
      auth: true,
      log: false, // for console
      ...meta,
    },
  })
}

export function getProjectNumbersReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case GET_PROJECT_NUMBERS: {
      return {
        data: {},
        loading: true,
        flag: false,
        error: false,
      }
    }
    case GET_PROJECT_NUMBERS_SUCCESS: {
      return {
        data: action.payload.data,
        loading: false,
        flag: true,
        error: false,
      }
    }
    case GET_PROJECT_NUMBERS_FAILURE: {
      return {
        data: {},
        loading: false,
        flag: false,
        error: true,
      }
    }
    default:
      return state
  }
}
